var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{staticClass:"canvas0",attrs:{"width":_vm.width,"height":_vm.height}}),_c('canvas',{staticClass:"canvas1",attrs:{"width":_vm.width,"height":_vm.height}}),_c('canvas',{staticClass:"canvas2",attrs:{"width":_vm.width,"height":_vm.height}})])
}
var staticRenderFns = []

export { render, staticRenderFns }